module.exports = __webpack_public_path__ + "static/img/device_switch.1d3a318.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/trackplus_2021/device_switch.png
// module id = VIfk
// module chunks = 1